import React from 'react'
import styled from 'styled-components'
import ImageCropper from 'react-image-crop'
import Button from '../../components/Button'

const EdittedImage = styled.div`
  margin-left: auto;
  margin-right: auto;
  transform: ${({ rotation = 0, mirrored }) => `
    rotate(${rotation * 90}deg)
    scale${rotation % 2 === 0 ? 'X' : 'Y'}(${mirrored ? '-1' : '1'})
  `};
`
const EditImagesButtonsBar = styled.div`padding: 0.25em;`
const EditImagesImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: lightgrey;
  max-width: 650px;
  margin: auto;
  img {
    max-width: 100%;
  }
`

const EditImagesScreen = ({
  images,
  currentImageIndex,
  handleChangeImageRotation,
  handleChangeImageMirror,
  getImageSrc,
  handleImageCrop,
  handleHandleImageSave,
  goToNextImage,
}) => {
  const image = images[currentImageIndex]
  const shouldInsert = images.length - 1 === currentImageIndex
  return (
    <div>
      <h3>Edit Images</h3>
      <p>Set crop on image before rotating or flipping.</p>
      <div>
        <EditImagesButtonsBar>
          <Button
            onClick={() =>
              handleChangeImageRotation(((image.rotation || 0) + 1) % 4)}>
            Rotate
          </Button>
          <Button onClick={() => handleChangeImageMirror(!image.mirror)}>
            Flip
          </Button>
        </EditImagesButtonsBar>
        <EditImagesImageContainer>
          <EdittedImage
            cropRect={image.cropRect}
            rotation={image.rotation}
            mirrored={image.mirror}>
            <ImageCropper
              src={getImageSrc(image)}
              onChange={handleImageCrop}
              crop={image.cropView}
            />
          </EdittedImage>
        </EditImagesImageContainer>
      </div>
      <p>Note: This only alters the image in this content/media section.</p>
      {shouldInsert ? (
        <Button
          raised
          primary
          onClick={handleHandleImageSave}
          style={{ display: 'block', marginLeft: 'auto' }}>
          Insert
        </Button>
      ) : (
        <Button
          onClick={goToNextImage}
          style={{ display: 'block', marginLeft: 'auto' }}>
          Next
        </Button>
      )}
    </div>
  )
}

export default EditImagesScreen



// WEBPACK FOOTER //
// ./src/components/ImageSelectionModal/EditImagesScreen.js